import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import { VariantProvider, useVariant } from './contexts/VariantContext';
import { SEOProvider } from './contexts/SEOContext';
import Navbar from './components/Navbar';
import VariantFooterWrapper from './components/VariantFooterWrapper';
import DynamicRouter from './components/DynamicRouter';
import DomainSwitcher from './components/DomainSwitcher';
import SEOHead from './components/SEOHead';

// ScrollToTop component to ensure page scrolls to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// AppContent component to use variant styles
const AppContent = () => {
  const { styles } = useVariant();
  
  
  return (
    <>
      <SEOHead />
      <div className={`flex flex-col min-h-screen ${styles.container}`}>
        <Navbar />
        <main className="flex-grow pt-20">
          <ScrollToTop />
          <DynamicRouter />
        </main>
        <VariantFooterWrapper />
        <DomainSwitcher />
      </div>
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <VariantProvider>
          <Router>
            <SEOProvider>
              <AppContent />
            </SEOProvider>
          </Router>
        </VariantProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App; 